import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Grid from "@material-ui/core/Grid";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import { instance } from "Actions/AxiosInstance";
import addPlusIcon from "Assets/newicons/action/add-plus/outline/add-plus-outline-16px-blue.svg";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import designationIcon from "Assets/newicons/attribute/designation/outline/designation-outline-16px.svg";
import kebabIcon from "Assets/newicons/user-interface/kebab/glyph/kebab-glyph-16px.svg";
import userIcon from "Assets/newicons/user/avatar/outline/avatar-outline-16px.svg";
import alpha from "Assets/Svg/alpha-numeric.svg";
import dton from "Assets/Svg/date.svg";
import drag from "Assets/Svg/drag.svg";
import dropdown from "Assets/Svg/dropdown-selection.svg";
import checkboxIcon from "Assets/Svg/list-checkbox.svg";
import num from "Assets/Svg/numerical.svg";
import classNames from "classnames";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import DrawerHeader from "Component/Headers/drawerHeader";
import LabelIcon from "Component/Labels/LabelIcon";
import { ErrorMessages } from "Constants";
import AddRequisition from "Module/Subscription/Recruit/AddRequisition";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const questioncategories = [
  {
    displayname: "Functional and role questions",
    displayvalue: 1,
  },
  {
    displayname: "New question",
    displayvalue: 2,
  },
];

const styles = () => ({
  drawerPaper: {
    width: "30%",
    padding: 16,
  },
});

class Requisitions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReview: props.selectedReview,
      screeningQuestionDrawer: false,
      saveincompany: false,
      moreoptions: false,
      moreoptions_anchorEl: null,
      questioncategoryid: null,
      description: "",
      answertypeid: 0,
      idx: "",
      postData: [{ fields: [{ option: [] }] }],
      option: [],
      isnotifyemployee: false,
      requisitionTitle: "",
      expanded: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.setInputType = this.setInputType.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addOption = this.addOption.bind(this);
    this.addMultiOption = this.addMultiOption.bind(this);
    this.removeOption = this.removeOption.bind(this);
    this.onMoreOptionsClick = this.onMoreOptionsClick.bind(this);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
    });
  }

  addOption() {
    const option = [];
    option.push({
      optionname: null,
    });
    this.setState({
      option,
    });
  }

  handleExpandClick = () => {
    this.setState((state) => ({
      expanded: !state.expanded,
    }));
  };

  addMultiOption() {
    const mulitiselectoption = [];
    mulitiselectoption.push({
      mulitiselectoptionname: null,
    });
    this.setState({
      mulitiselectoption,
    });
  }

  removeOption(index, i) {
    const { postData } = this.state;
    if (
      postData.fields &&
      postData.fields[index] &&
      postData.fields[index].option &&
      postData.fields[index].option[i]
    ) {
      postData.fields[index].option.splice(i, 1);
      this.setState(
        {
          postData,
        },
        () => {
          this.props.updatePostData(postData);
        },
      );
    }
  }

  setInputType(answertypeid) {
    this.setState({
      answertypeid,
    });
  }

  onMoreOptionsClick(event) {
    this.setState({
      moreoptions: !this.state.moreoptions,
      moreoptions_anchorEl: event.currentTarget,
    });
  }

  handleChange(key, value) {
    this.setState({
      [key]: value,
    });
  }

  onSubmit = () => {
    const { selectedReview } = this.state;
    selectedReview.isdraft = false;
    const structure = selectedReview;
    let selectedData = selectedReview.participant.filter(
      (x) => x.isSelected == true,
    );

    const isCheck = selectedData.map((x) => {
      if (x.openday == null) {
        return false;
      }
      if (x.closeday == null) {
        return false;
      }
      if (selectedReview.reviewperiodtypeid != 1 && x.frequencytypeid == null) {
        return false;
      }
      return true;
    });
    if (isCheck == false) {
      this.props.enqueueSnackbar("Please fill the data", { variant: "error" });
    } else {
      selectedData = selectedData.map((item) => {
        delete item.isSelected;
        return item;
      });
      structure.participant = selectedData;
      instance
        .post("perform/createreviewstructure", structure)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.history.push(`${this.props.match.path}/list`);
          this.props.getReviewStructure();
          this.setState({
            selectedReview: null,
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  };

  render() {
    const {
      questioncategoryid,
      description,
      answertypeid,

      idx,
      saveincompany,
    } = this.state;
    const { classes } = this.props;

    return (
      <div className="stepper-data">
        <ExpansionPanel
          expanded={this.state.expanded}
          onChange={() => this.handleExpandClick(this.state.expanded)}
          className="rounded-rectangle-paper rounded-rectangle-div padding0"
          style={{ border: "1px solid #1E8CED" }}
        >
          <ExpansionPanelSummary
            // expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            style={this.state.expanded ? { height: 0, minHeight: 0 } : {}}
          >
            {!this.state.expanded ? (
              <div>
                <span className="margin-right-8">
                  <img src={addPlusIcon}></img>
                </span>
                <p className="small-blue inline-block">Add new requisition</p>
              </div>
            ) : (
              ""
            )}
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className="display-block padding-top-24 padding-bottom-24">
            <AddRequisition />
            <div style={{ width: 350 }} className="margin-top-16">
              <p className="normal-dark-secondary margin-bottom-8">
                Screening questions (Functional)
              </p>
            </div>
            <Paper
              className="rounded-rectangle-paper margin-bottom-16"
              style={{ padding: "8px 32px" }}
            >
              <Grid container>
                <Grid item md={1} sm={12}>
                  <img src={drag} className="vertical-middle"></img>
                </Grid>
                <Grid item md={11} sm={12}>
                  <div className="floatleft">
                    <p className="small-dark-secondary t-bold padding-top-8">
                      Who is your favorite superhero of all time? Why do you
                      feel this way?
                    </p>
                  </div>
                  <div
                    className="floatright padding-top-10"
                    onClick={this.onMoreOptionsClick}
                  >
                    <img src={kebabIcon}></img>
                  </div>
                  <Popover
                    open={this.state.moreoptions}
                    anchorEl={this.state.moreoptions_anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    onClose={() => this.setState({ moreoptions: false })}
                    className="margin-top-8"
                  >
                    <Paper style={{ width: 190 }}>
                      <div>
                        <MenuListComponent>
                          <ListItem
                            className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                            onClick={this.onEdit}
                          >
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">Edit</span>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                            onClick={this.onDelete}
                          >
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                Delete
                              </span>
                            </ListItemText>
                          </ListItem>
                        </MenuListComponent>
                      </div>
                    </Paper>
                  </Popover>
                </Grid>
              </Grid>
            </Paper>
            <div style={{ width: 350 }} className="margin-top-16">
              <Button
                className="btn btn-secondary-md-blue"
                variant="contained"
                onClick={() => this.setState({ screeningQuestionDrawer: true })}
              >
                Add screening question
              </Button>
            </div>
            <Button
              className="btn btn-primary-md-blue margin-top-16"
              variant="contained"
              onClick={() => this.setState({ screeningQuestionDrawer: true })}
            >
              Add requisition
            </Button>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <div className="dashed-divider1"></div>
        <Paper className="rounded-rectangle-paper padding24">
          <p className="normal-dark-secondary t-bold margin-bottom-16">
            UX Designers for Payroll
          </p>
          <img src={kebabIcon}></img>
          <div
            className="rounded-rectangle-div margin-bottom-16"
            style={{ width: 230 }}
          >
            <LabelIcon label="UX Designer" img={designationIcon} />
            <div>
              <span className="floatleft">
                <LabelIcon label="employee namee" img={userIcon} />
              </span>
              <span className="floatright">
                <p className="extra-small-dark-secondary margin-top-6">
                  3 positions
                </p>
              </span>
              <div className="clear-float"></div>
            </div>
          </div>
        </Paper>
        <Drawer
          anchor="right"
          open={this.state.screeningQuestionDrawer}
          onClose={() =>
            this.setState({
              screeningQuestionDrawer: false,
            })
          }
          classes={{
            paper: classNames(classes.drawerPaper, "planner-drawer"),
          }}
        >
          <DrawerHeader
            header="Add screening question"
            isbackarrow={false}
            closeDrawer={() =>
              this.setState({
                screeningQuestionDrawer: false,
              })
            }
          />
          <Grid container>
            <Grid item xs={12} md={8} sm={12}>
              <div style={{ width: 300 }}>
                <DynamicForm
                  fields={selectinputconverter({
                    value: questioncategoryid,
                    placeholder: "Select category",
                    label: "Question category",
                    options: questioncategories,
                  })}
                  onChange={(selectedid) => {
                    this.handleChange("questioncategoryid", selectedid);
                  }}
                />
                {questioncategoryid == 1 && (
                  <DynamicForm
                    fields={selectinputconverter({
                      value: this.state.questioncategoryid,
                      placeholder: "Select question",
                      label: "Question",
                      options: this.state.questioncategories,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("questioncategoryid", selectedid);
                    }}
                  />
                )}

                {questioncategoryid == 2 && (
                  <div>
                    <DynamicForm
                      className="width50"
                      fields={textareainputconverter({
                        value: description,
                        placeholder: "Enter question",
                        label: "Question",
                      })}
                      onChange={(value) => {
                        this.handleChange(value, "description");
                      }}
                    />
                    <p className="small-dark-secondary margin-bottom-8">
                      Answer type
                    </p>
                    <div className="margin-bottom-8">
                      <img
                        src={alpha}
                        style={{
                          marginRight: 16,
                          cursor: "pointer",
                          border:
                            answertypeid == 1
                              ? "2px solid #1e8ced"
                              : "2px solid transparent",
                          borderRadius: 20,
                        }}
                        onClick={() => this.setInputType(1)}
                      ></img>
                      <img
                        src={num}
                        style={{
                          marginRight: 16,
                          cursor: "pointer",
                          border:
                            answertypeid == 2
                              ? "2px solid #1e8ced"
                              : "2px solid transparent",
                          borderRadius: 20,
                        }}
                        onClick={() => this.setInputType(2)}
                      ></img>
                      <img
                        src={dton}
                        style={{
                          marginRight: 16,
                          cursor: "pointer",
                          border:
                            answertypeid == 3
                              ? "2px solid #1e8ced"
                              : "2px solid transparent",
                          borderRadius: 20,
                        }}
                        onClick={() => this.setInputType(3)}
                      ></img>
                      <img
                        src={dropdown}
                        style={{
                          marginRight: 16,
                          cursor: "pointer",
                          border:
                            answertypeid == 4
                              ? "2px solid #1e8ced"
                              : "2px solid transparent",
                          borderRadius: 20,
                        }}
                        onClick={() => this.setInputType(4)}
                      ></img>
                      <img
                        src={checkboxIcon}
                        style={{
                          marginRight: 16,
                          cursor: "pointer",
                          border:
                            answertypeid == 5
                              ? "2px solid #1e8ced"
                              : "2px solid transparent",
                          borderRadius: 20,
                        }}
                        onClick={() => this.setInputType(5)}
                      ></img>
                    </div>
                    {this.state.option &&
                      answertypeid == 4 &&
                      this.state.option.map((x, i) => (
                        <Grid container className="margin-top-8" spacing={2}>
                          <Grid item md={11} sm={12}>
                            <DynamicForm
                              fields={textinputconverter({
                                value: x.optionname,
                                placeholder: "Enter option",
                                label: `Option ${i + 1}`,
                              })}
                              onChange={(e) => {
                                this.handleChange(e, "optionname", idx, i);
                              }}
                            />
                          </Grid>
                          <Grid item md={1} sm={12}>
                            <img
                              src={deleteIcon}
                              style={{
                                display: "table",
                                marginRight: 8,
                                marginTop: 26,
                                cursor: "pointer",
                              }}
                              onClick={() => this.removeOption(idx, i)}
                            ></img>
                          </Grid>
                        </Grid>
                      ))}
                    {answertypeid == 4 && (
                      <Button
                        className="btn btn-secondary-md-blue width100"
                        onClick={() => this.addOption()}
                      >
                        Add option
                      </Button>
                    )}

                    {this.state.mulitiselectoption &&
                      answertypeid == 5 &&
                      this.state.mulitiselectoption.map((x, i) => (
                        <Grid container className="margin-top-8" spacing={2}>
                          <Grid item md={11} sm={12}>
                            <DynamicForm
                              fields={textinputconverter({
                                value: x.optionname,
                                placeholder: "Enter item",
                                label: `Item ${i + 1}`,
                              })}
                              onChange={(e) => {
                                this.handleChange(e, "optionname", idx, i);
                              }}
                            />
                          </Grid>
                          <Grid item md={1} sm={12}>
                            <img
                              src={deleteIcon}
                              style={{
                                display: "table",
                                marginRight: 8,
                                marginTop: 26,
                                cursor: "pointer",
                              }}
                              onClick={() => this.removeOption(idx, i)}
                            ></img>
                          </Grid>
                        </Grid>
                      ))}

                    {answertypeid == 5 && (
                      <Button
                        className="btn btn-secondary-md-blue width100"
                        onClick={() => this.addMultiOption()}
                      >
                        Add item
                      </Button>
                    )}
                    <div style={{ width: 400, marginTop: 16 }}>
                      <DynamicForm
                        fields={checkboxinputconverter({
                          value: saveincompany,
                          placeholder: "",
                          label: "Save in Company & Culture questions",
                        })}
                        onChange={(e) => {
                          this.handleChange(e, "saveincompany", idx);
                        }}
                      />
                    </div>
                  </div>
                )}
                <Button
                  color="primary"
                  variant="contained"
                  type="button"
                  className="btn btn-primary-md-blue margin-top-8"
                  // onClick={this.onSave}
                >
                  Add question
                </Button>
              </div>
            </Grid>
          </Grid>
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
  Language: state.LanguageAction.Language,
  holidayPlanReducer: state.holidayPlanReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(withSnackbar(Requisitions)),
);
